import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ClearIcon from "@mui/icons-material/Clear";
import Slide from "@mui/material/Slide";

import AddFlightModal from "./AddFlightModal";
import { BsPlusLg } from "react-icons/bs";
import {
  // addNewFlight,
  getAircraft,
  getFlightData,
  // getAircraftdefault,
} from "../Axios/Axios";
import PreviewModal from "./PreviewModal";
import AircraftModels from "../../pages/Dashboard/Aircraft/aircraftModels";
import AddAircraftModal from "./AddAircraftModal";
const style = {
  position: "fixed",
  top: "0",
  right: "0",
  width: "60%",
  height: "900px",
  maxWidth: "500px",
  maxHeight: "100%",
  bgcolor: "white",
  boxShadow: 24,
  paddingLeft: "5%",
  paddingRight: "3%",
  overflow: "auto",
  zIndex: 9999,

  "&::-webkit-scrollbar": {
    //Beautifying scrollbar
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
};

interface AddFlightManualprops {
  open: boolean;
  onCloseFm: () => void;
  onOpenAuto: () => void;
  // landingsprop: number;
}

const AddFlightManual: React.FC<AddFlightManualprops> = ({
  open,
  onCloseFm,
  onOpenAuto,
  // landingsprop,
}) => {
  console.log(open, "open auto");
  const [crewPositions, setCrewPositions] = useState<
    { label: string; value: string }[]
  >([]);
  const [userInput, setUserInput] = useState<UserInput>({}); // Use the UserInput type

  const [formsubmit, setFormSubmit] = React.useState(false);
  const [selectedAircraft, setSelectedAircraft] = useState<string>("");
  const [aircraftData, setAircraftData] = useState<any>([]);
  const [aircraftModels, setAircraftModels] = useState<any>([]);
  const [aircraftDefault, setAircraftDefault] = useState("");
  const [userName, setUserName] = useState("");
  const [flightNumber, setFlightNumber] = useState("");
  const [flightId, setFlightId] = useState("");
  const [date, setDate] = useState("");
  const [fromLoc, setFromLoc] = useState("");
  const [toLoc, setToLoc] = useState("");
  const [actualIn, setActualIn] = useState("");
  const [actualOut, setActualOut] = useState("");
  const [crewOptionsPresent, setCrewOptionsPresent] = useState<
    Array<Array<CrewOption>>
  >([]);
  const [totalTime, setTotalTime] = useState<number>(0);
  const [day, setDay] = useState<number>(0);
  const [night, setNight] = useState<number>(0);
  const [landingCheck, setLandingCheck] = useState("");
  const [landingDay, setLandingDay] = useState<number>(0);
  const [landingNight, setLandingNight] = useState<number>(0);
  const [takesOffDay, setTakesOffDay] = useState<number>(0);
  const [takesOffNight, setTakesOffNight] = useState<number>(0);
  const [approachesCheck, setApproachesCheck] = useState("");
  const [approachesInput, setApproachesInput] = useState("");
  const [instrumentTimePercentageInput, setInstrumentTimePercentageInput] =
    useState("");
  const [actualOn, setActualOn] = useState("");
  const [actualOff, setActualOff] = useState("");
  const [instrumentTimePercentageCheck, setInstrumentTimePercentageCheck] =
    useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [route, setRoute] = useState("");
  const [fromCity, setFromcity] = useState("");
  const [toCity, setTocity] = useState("");
  const [
    autofilledValueInstrumentTimePercent,
    setAutofilledValueInstrumentTimePercent,
  ] = useState("");
  const [showNestedList, setShowNestedList] = React.useState(false);
  const [aircraftNestedList, setAircraftNestedList] = React.useState(false);
  const [addAircraft, setAddAircraft] = React.useState(false);
  const [registrationNo, setRegistrationNo] = useState("");
  const [aircarftid, setAircarftid] = React.useState("");
  const [aircraftType, setAircraftType] = React.useState("");
  const [remarks, setRemarks] = React.useState("");
  const [crossCountry,setCrossCountry]=React.useState(false);
  const [crossCountryTime,setCrossCountryTime]=React.useState<number>(0);
  const [routeDistance,setRouteDistance]=React.useState<number>(0);
  const [departureDelay,setDepartureDelay]=React.useState<number>(0);
  const [arrivalDelay,setArrivalDelay]=React.useState<number>(0);

  const handleAddAircraft = () => {
    setAddAircraft(true);
  };

  const handleCloseAircraft = () => {
    setAddAircraft(false);
  };

  const handleInstrumentTimePercentageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setInstrumentTimePercentageInput(event.target.value);
  };

  const calculateAutofilledValueInstrumentTimePercent = () => {
    const percentage = parseFloat(instrumentTimePercentageInput);
    if (!isNaN(percentage)) {
      const calculatedValue = (percentage / 100) * totalTime;
      setAutofilledValueInstrumentTimePercent(calculatedValue.toFixed(2));
    }
  };

  React.useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setUserName(storedUsername);
    }
  }, [userName]);

  const resetAllStates = () => {
    setCrewPositions([]);
    setUserInput({});
    // setAircraftIndex(-1);
    // setShowFromToFields(false);
    setSelectedAircraft("");
    setFormSubmit(false);
    setUserName("David");
    setAircraftData([]);
    setAircraftModels([]);
    setFlightId("");
    setFlightNumber("");
    setFromLoc("");
    setToLoc("");
    setActualIn("");
    setActualOut("");
    setActualOn("");
    setActualOff("");
    setDate("");
    setTotalTime(0);
    setDay(0);
    setNight(0);
    setRoute("");
    setFromcity("");
    setTocity("");
    // setLoading(false);
    // setError("");
    setInstrumentTimePercentageCheck("");
    setApproachesCheck("");
    setInstrumentTimePercentageInput("");
    setApproachesInput("");
    setCrewOptionsPresent([]);
    setIsModalOpen(false);
    setLandingCheck("");
    setLandingDay(0);
    setLandingNight(0);
    setTakesOffDay(0);
    setTakesOffNight(0);
    setAircraftDefault("");
    // setAircraftModelsDefault("");
    // setToggleState({ auto: true });
    // setIsAutoMode(true);
    // setIsToggled(false);
  };
  const handleDayBlur = () => {
    const dayValue = typeof day === "number" ? day : parseFloat(day); // Convert to float
    const remainingTime = Number(totalTime) - dayValue;
    if (!isNaN(remainingTime) && remainingTime >= 0) {
      const roundedNight = parseFloat(remainingTime.toFixed(2));
      setNight(roundedNight);
    }
  };
  
  const handleNightBlur = () => {
    const nightValue = typeof night === "number" ? night : parseFloat(night); // Convert to float
    const remainingTime = Number(totalTime) - nightValue;
    if (!isNaN(remainingTime) && remainingTime >= 0) {
      const roundedDay = parseFloat(remainingTime.toFixed(2));
      setDay(roundedDay);
    }
  };

  const handleUserInputBlur = (label:any, value:any) => {
    setUserInput({
      ...userInput,
      [label]: value,
    });
  };
  
  const handleCrossCountry = (event: any) => {
    setCrossCountry(!crossCountry);
    if(crossCountry===true)
    {
    setCrossCountryTime(totalTime);
    }
    console.log(crossCountry);
   
  };

  const handleTotalTime = (e:any) => {
    const newValue = Number(e.target.value);

    // Assuming you want to set both totalTime and crossCountryTime to the same value
    setTotalTime(newValue);
    if(crossCountry===true)
    {
    setCrossCountryTime(newValue);
    }
    console.log(crossCountryTime)
  };
  

  

  interface CrewOption {
    label: string;
  }
  type UserInput = {
    [key: string]: string;
  };

  const updateCrewPosition = (inputName: string, inputValue: string) => {
    const updatedCrewPositions = crewPositions.map((position) =>
      position.label === inputName
        ? { ...position, value: inputValue }
        : position
    );
    setCrewPositions(updatedCrewPositions);
  };

  const handleCloseFlightModal = () => {
    setIsModalOpen(false);
  };
  const handleOpenPreview = () => {
    setIsModalOpen(true);
  };
  const handleClosePreview = () => {
    setIsModalOpen(false);
  };

  const handleAircraftChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAircraft(e.target.value);
    console.log(e.target.value);

    try {
      const selectedIndex =
        e.target.options[e.target.selectedIndex].getAttribute("data-index");
      if (selectedIndex !== null) {
        // Convert selectedIndex to a number (it's a string by default)
        const index = parseInt(selectedIndex, 10);

        // Now you can use the index in your logic
        // console.log("Selected Index:", index);
        const data = aircraftData[index];
        setRegistrationNo(data.registrationNo);
        setAircarftid(data._id);
        setAircraftType(data.model);
        setInstrumentTimePercentageCheck(data.instrumentTimePercentage);
        setInstrumentTimePercentageInput(data.instrumentTimePercentage);
        setApproachesCheck(data.approaches);
        setLandingCheck(data.landing);

        // if (landingCheck === "1") {
        //   setTakesOffDay(1);
        //   setLandingDay(1);}
        //  else {
        //   setTakesOffDay(Number(e.target.value));
        //   setLandingDay(Number(e.target.value));
        // }
        setCrewOptionsPresent(data.defaultCrewPosition);
      }
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    // Define a flag to prevent the effect from running when aircraftModels change
    let shouldRunEffect = true;
  
    async function fetchData() {
      try {
        const data = await getAircraft();
        // const data4: any = await getAircraftdefault(data2);
        // setAircraftDefault(data4);
        const data3 = data;
        setAircraftData(data3);
        console.log("data of aircraft", data3); // Aircraft data
  
        if (shouldRunEffect) {
          const updatedAircraftModels = data3.map((entry:any) => entry.model);
          setAircraftModels(updatedAircraftModels);
        }
      } catch (error) {
        console.error("Error fetching aircraft data:", error);
        // Handle errors as needed (e.g., show an error message)
      }
    }
  
    fetchData();
  
    // Return a cleanup function to reset the flag when the component unmounts
    return () => {
      shouldRunEffect = false;
    };
  }, [userName]);

  const handleKeyPress = (e:any) => {
    // Check if the pressed key is Enter (key code 13)
    if (e.key === 'Enter') {
      // Check if the event target is not an input element inside the modal
      if (!e.target.closest('.modal input')) {
        // Prevent the modal switch logic from executing
        e.preventDefault();
      }
    }
  };
  
  
  return (
    <>
      <Modal open={open} onClose={onCloseFm}  onKeyPress={handleKeyPress}>
        <Slide direction="left" in={open} mountOnEnter unmountOnExit>
          <Box sx={style}>
            <form action="">
              <div>
                <div className="clear_icon">
                  <ClearIcon style={{ marginTop: "2%" }} onClick={onCloseFm} />
                </div>
                <h2 className="heading2">Add New Flight</h2>

                <p className="heading4 secondary" style={{ fontWeight: "600" }}>
                  Flight Details
                </p>
                <div
                  className="f-flex"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <label className="heading5" style={{ marginBottom: "5px" }}>
                    Flight
                  </label>

                  <div>
                    <button
                      className="add_flight_btn"
                      style={{
                        marginBottom: "15px",
                        background: "#F69110",
                        marginLeft: "90%",
                      }}
                      onClick={() => {
                        // onClose();
                        onOpenAuto();
                      }}
                    >
                      <span>Manual</span>
                    </button>
                  </div>

                  <button
                    onClick={handleAddAircraft}
                    type="button"
                    className="add_flight_btn"
                    style={{ marginBottom: "15px", marginLeft: "20%" }}
                  >
                    <BsPlusLg /> Add Aircraft
                  </button>
                  <AddAircraftModal
                    open={addAircraft}
                    onClose={handleCloseAircraft}
                  />
                </div>

                <div
                  className="add_group"
                  style={{ width: "100%", position: "relative" }}
                >
                  <input
                    type="text"
                    className="add_input"
                    placeholder="Select Aircraft"
                    value={selectedAircraft}
                    readOnly
                    style={{ zIndex: 2 }}
                    onChange={(e) => setSelectedAircraft(e.target.value)}
                  />
                  <select
                    className="add_input"
                    value={selectedAircraft}
                    onChange={handleAircraftChange}
                  >
                    <option value="" disabled selected>
                      Select your Aircraft
                    </option>
                    {aircraftModels.map((model: any, index: any) => (
                      <option key={index} value={model} data-index={index}>
                        {model}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="f-flex">
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Flight Number
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                      marginRight: "10%",
                    }}
                  >
                    Date
                  </label>
                </div>

                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="UTF3235"
                      className="add_input"
                      onChange={(e) => setFlightNumber(e.target.value)}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="date"
                      placeholder="Select"
                      className="add_input"
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                </div>

                <div className="f-flex">
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    From
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    To
                  </label>
                </div>
                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="UK"
                      className="add_input"
                      onChange={(e) => setFromLoc(e.target.value)}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="USA"
                      className="add_input"
                      onChange={(e) => setToLoc(e.target.value)}
                    />
                  </div>
                </div>
                <div className="f-flex">
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Out (UTC)
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    In (UTC)
                  </label>
                </div>
                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="+9:00"
                      className="add_input"
                      onChange={(e) => setActualOut(e.target.value)}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="+12:00"
                      className="add_input"
                      onChange={(e) => setActualIn(e.target.value)}
                    />
                  </div>
                </div>

                <p className="heading4 secondary" style={{ fontWeight: "600" }}>
                  TIME
                </p>
                <div className="add_span" style={{ flexGrow: "1" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="cross_country"
                    name="cross_country"
                    onChange={handleCrossCountry}
                    checked={crossCountry}
                  />
                  <label className="heading5">Cross Country</label>
                </div>
                <div style={{ display: "flex", flexGrow: "1" }}>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Total Time
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Day
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                      marginLeft: "7%",
                    }}
                  >
                    Night
                  </label>
                </div>
                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="hours"
                      className="add_input"
                      onChange={handleTotalTime}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="hours"
                      className="add_input"
                      onChange={(e) => setDay(Number(e.target.value))}
                      onBlur={handleDayBlur}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="hours"
                      className="add_input"
                      onChange={(e) => setNight(Number(e.target.value))}
                      onBlur={handleNightBlur}
                    />
                  </div>
                </div>
                <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      marginBottom: "1rem",
                      gap: "5%",
                    }}
                  >
                    {crewOptionsPresent &&
                    crewOptionsPresent[0] &&
                    crewOptionsPresent[0].length > 0 ? (
                      crewOptionsPresent[0].map((option) => (
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                          key={option.label} // Add a unique key for each element
                        >
                          {option.label}
                          {crewOptionsPresent[0].length > 1 ? (
                            <input
                              className="add_group"
                              style={{
                                display: "flex",
                                width: "80%",
                                WebkitAppearance: "none",
                              }}
                              type="text"
                              placeholder={option?.label}
                              onChange={(e) => {
                                setUserInput({
                                  ...userInput,
                                  [option.label]: e.target.value,
                                });
                              }}
                            />
                          ) : (
                            <input
                              className="add_group"
                              style={{
                                display: "flex",
                                width: "80%",
                              }}
                              type="text"
                              // placeholder={totalTime}
                              value={
                                userInput[option.label] == undefined
                                  ? userInput[option.label]
                                  : totalTime
                              }
                              onChange={(e) => {
                                setUserInput({
                                  ...userInput,
                                  [option.label]: e.target.value,
                                });
                              }}
                              onBlur={()=>handleUserInputBlur(option.label,totalTime)}
                              // disabled
                              // inputMode="none"
                            />
                          )}
                        </div>
                      ))
                    ) : (
                      <>
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                          // Add a unique key for each element
                        >
                          PIC
                          <input
                            className="add_group"
                            style={{
                              display: "flex",
                              width: "80%",
                              WebkitAppearance: "none",
                            }}
                            type="text"
                            placeholder="PIC"
                            onChange={(e) => {
                              setUserInput({
                                ...userInput,
                                ["PIC"]: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                        >
                          SIC
                          <input
                            className="add_group"
                            style={{
                              display: "flex",
                              width: "80%",
                              WebkitAppearance: "none",
                            }}
                            type="text"
                            placeholder="SIC"
                            onChange={(e) => {
                              setUserInput({
                                ...userInput,
                                ["SIC"]: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                          // Add a unique key for each element
                        >
                          EP
                          <input
                            className="add_group"
                            style={{
                              display: "flex",
                              width: "80%",
                              WebkitAppearance: "none",
                            }}
                            type="text"
                            placeholder="EP"
                            onChange={(e) => {
                              setUserInput({
                                ...userInput,
                                ["EP"]: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                        >
                          IP
                          <input
                            className="add_group"
                            style={{
                              display: "flex",
                              width: "80%",
                              WebkitAppearance: "none",
                            }}
                            type="text"
                            placeholder="IP"
                            value={userInput.ip}
                            onChange={(e) => {
                              setUserInput({
                                ...userInput,
                                ["IP"]: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>

                <div style={{ display: "flex" }}>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Takeoffs
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Landings
                  </label>
                </div>
                <div className="f-flex" style={{ gap: "8px" }}>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="Day"
                      className="add_input"
                      onChange={(e) => setTakesOffDay(Number(e.target.value))}
                    />
                  </div>

                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="Night"
                      className="add_input"
                      onChange={(e) => setTakesOffNight(Number(e.target.value))}
                    />
                  </div>

                  <div className="f-flex" style={{ gap: "8px" }}>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="Day"
                        className="add_input"
                        onChange={(e) => setLandingDay(Number(e.target.value))}
                      />
                    </div>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="Night"
                        className="add_input"
                        onChange={(e) => setLandingNight(Number(e.target.value))}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" , gap:"30%"}}
                >
                  {/* Approaches */}
                  {approachesCheck === "" ? (
                    <div>
                      <p className="heading5">Approaches</p>
                      <input
                        className="add_group"
                        style={{ width: "170%" }}
                        type="text"
                        placeholder="Enter"
                        onChange={(e) => setApproachesInput(e.target.value)}
                      />
                    </div>
                  ) : null}
                  {/* Approaches end */}

                  {/* Instrument Time Percentage */}
                  {instrumentTimePercentageCheck === "" ? (
                    <div style={{ marginRight: "5%" }}>
                      <p className="heading5">Instrument Time %</p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <input
                          style={{ width: "63%" }}
                          className="add_group"
                          type="text"
                          placeholder="%"
                          value={instrumentTimePercentageInput}
                          onChange={handleInstrumentTimePercentageChange}
                          onBlur={calculateAutofilledValueInstrumentTimePercent}
                        />

                        <input
                          style={{ width: "80%" }}
                          className="add_group"
                          type="text"
                          placeholder="value"
                          value={autofilledValueInstrumentTimePercent}
                          disabled
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
                <div
                  className="f-flex"
                  style={{ display: "flex", flexGrow: "1" }}
                >
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Out (UTC)
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    In (UTC)
                  </label>
                </div>
                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="+9:00"
                      className="add_input"
                      onChange={(e) => setActualOff(e.target.value)}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="+12:00"
                      className="add_input"
                      onChange={(e) => setActualOn(e.target.value)}
                    />
                  </div>
                </div>
                <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                     Remarks
                  </label>
                  <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1",height:"100px",width:"100%" }}
                    >
                      <textarea
                      style={{resize:"none",height: "80px"}}
                        placeholder="Enter your remarks"
                        className="add_input"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />
                    </div>

                <div>
                  <button
                    type="button"
                    className="add_btn"
                    style={{ float: "right" }}
                    onClick={handleOpenPreview}
                  >
                    <span>Preview Flight</span>
                  </button>

                  <PreviewModal
                    open={isModalOpen}
                    onClosePr={handleClosePreview}
                    onCloseFm={handleCloseFlightModal}
                    flightId={flightId}
                    aircraftId={aircarftid}
                    selectedAircraft={selectedAircraft}
                    registrationNo={registrationNo}
                    aircraftType={aircraftType}
                    flightNumber={flightNumber}
                    fromLoc={fromLoc}
                    toLoc={toLoc}
                    date={date}
                    actualOut={actualOut}
                    actualIn={actualIn}
                    totalTime={totalTime}
                    day={day}
                    night={night}
                    landingDay={landingDay}
                    landingNight={landingNight}
                    approachesInput={approachesInput}
                    autofilledValueInstrumentTimePercent={
                      autofilledValueInstrumentTimePercent
                    }
                    takesOffDay={takesOffDay}
                    takesOffNight={takesOffNight}
                    crewOptionsPresent={crewOptionsPresent}
                    userInput={userInput}
                    actualOff={actualOff}
                    actualOn={actualOn}
                    resetAllStates={resetAllStates}
                    route={route}
                    fromCity={fromCity}
                    toCity={toCity}
                    crossCountry={crossCountryTime}
                    routeDistance={routeDistance}
                    arrivalDelay={arrivalDelay}
                    departureDelay={departureDelay}
                  />

                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </form>
          </Box>
        </Slide>
      </Modal>
    </>
  );
};

export default AddFlightManual;
